 export default class Utils {
  constructor() {
    this.setDataURLs();
  }
  setDataURLs() {
    if ($('[data-url-external]')) {
      $('[data-url-external]').each(function() {
        var url, that;
        that = $(this);
        url = that.attr('data-url-external');
        that.on('click', function() {
          window.open(url, '_blank');
        });
        that.find('a').on('click', function(event) {
    	event.preventDefault();
        });
      });
    }
    if ($('[data-url]')) {
      $('[data-url]').each(function() {
        var url, that;
        that = $(this);
        url = that.attr('data-url');
        that.on('click', function() {
          window.location = url;
        });
        that.find('a').on('click', function(event) {
    	event.preventDefault();
        });
      });
    }
  }
}